import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import TransactionDetailsModal from '../../../pages/Blocks/TransactionDetailsModal';
import kalpLogo2 from '../../../assets/images/kalp-expl-logo-2.png';
import { useDefaultContext } from '../../../contexts/HomeContext';
import kalpLogo from '../../../assets/images/kalp-expl-logo.png';
import CustomDropdownSearch from '../../CustomDropdownSearch';
import { useTheme } from '../../../contexts/ThemeContext';
import useDebounce from '../../../hooks/useDebounce';
import MenuIcon from '../../../assets/svg/MenuSVG';
import { SearchIcon } from '../../../assets/svg';
import CustomModal from '../../CustomModal';
import { Row, Col } from 'react-bootstrap';
import { path } from '../../../constants';
import NavbarTabs from '../../NavbarTabs';
import './SubHeader.scss';
import Loader from "../../Loader";

const options = [
  {
    label: 'Transaction Id',
    value: 'transactionId',
  },
  {
    label: 'Block No',
    value: 'blockNumber'
  }, {
    label: 'Smart Contract Address',
    value: 'chaincodeName'
  }];

const SubHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const ref = useRef<HTMLDivElement>(null);

  const { darkTheme } = useTheme();
  const { globalSearch } = useDefaultContext();

  const [searchValue, setSearchValue] = useState<string>('');
  const [selectedOption, setSelectedOption] = useState<any>(options[0]);
  const [globalError, setGlobalError] = useState<string>('');
  const [detailsData, setDetailsData] = useState<any>();
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isMobileSearch, setIsMobileSearch] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const toggleTransactionModal = (items?: any) => {
    setDetailsData(items);
    setIsOpenModal((prev) => !prev);
  };

  const debouncedFn = useDebounce(async (value: string, option: string) => {
    if (value) {
      setIsLoading(true);
      const res: any = await globalSearch({value, searchType: option});
      if (option === 'transactionId' && res?.data?.type === 'transaction') {
        if (Number(res.data.totalResults) === 0) {
          setGlobalError(res.data.message || 'No data found');
        } else {
          setGlobalError('');
          toggleTransactionModal(res?.data?.data?.[ 0 ]);
        }
      } else if (option === 'blockNumber' && res?.data?.type === 'block') {
        if (Number(res.data.totalResults) === 0) {
          setGlobalError(res.data.message || 'No data found');
        } else {
          setGlobalError('');
          navigate(`${path.BLOCKS}/${res.data.data[ 0 ].blockid}`);
        }
      } else if (option === 'chaincodeName' && res?.data?.type === 'chaincode') {
        if (res.data.data.length < 1 || res?.data?.message) {
          setGlobalError(res?.data?.message || 'No data found');
        } else {
          setGlobalError('');
          navigate(`${path.SMART_CONTRACT}/${value}`);
        }
      } else {
        setGlobalError('Please enter valid data');
      }
      setIsLoading(false)
    }
  }, 800);

  const handleMobileSearchFilter = () => {
    setIsMobileSearch(true);
  };

  const handleMobileSearchClose = () => {
    setIsMobileSearch(false);
    setSearchValue('');
    setGlobalError('');
  };

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
    debouncedFn(value, selectedOption.value);
    if (!value) {
      setGlobalError('');
    }
  };

  const handleSelectOption = (option: any) => {
    setSelectedOption(option);
    debouncedFn(searchValue, option.value);
  };

  const handleResize = () => {
    if (window.innerWidth >= 1019) {
      setIsMobileSearch(false);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref?.current && !ref?.current?.contains(event?.target as Node) && !isLoading) {
        setSearchValue('');
        setGlobalError('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, isLoading]);


  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <Row className={`sub-header-main ${isMobileSearch ? 'justify-content-center p-0' : ''}`}>
      <Col xs={2} sm={2} className={`p-0 resp-logo ${isMobileSearch ? 'res-logo-none' : ''}`}>
        {darkTheme ? (
          <img src={kalpLogo2} className="logo" alt="logo" onClick={() => navigate(path.HOME)}/>
        ) : (
          <img src={kalpLogo} className="logo" alt="logo" onClick={() => navigate(path.HOME)}/>
        )}
      </Col>
      {
        isLoading && <Loader />
      }
      <Col xs={6} sm={6} className={`p-0  ${isMobileSearch ? 'w-100' : ''}`} ref={ref}>
        <div className="web-search">
          <CustomDropdownSearch
            options={options}
            searchValue={searchValue}
            isLoading={isLoading}
            searchPlaceholder="Search by address, transactions, blocks etc.."
            onSearchChange={handleSearchChange}
            searchStyle={`${globalError && 'search-border-error'}`}
            onSelectOption={handleSelectOption}
          />
          {globalError && (
            <span className="search-error">{globalError ? globalError : 'Please enter valid data'}</span>
          )}
        </div>
        <div className="resp-search">
          <div onClick={handleMobileSearchFilter} className={isMobileSearch ? 'd-none' : ''}>
            {!isMobileSearch && <SearchIcon color="#1C1C1C" />}
          </div>
            {isMobileSearch && (
              <div className="resp-searchbar-wrapper">
                <CustomDropdownSearch
                  options={options}
                  searchValue={searchValue}
                  searchPlaceholder="Search by address, transactions, blocks etc.."
                  onSearchChange={handleSearchChange}
                  searchStyle={`${globalError && 'search-border-error'}`}
                  onSelectOption={handleSelectOption}
                  optionStyles={darkTheme ? 'border-0' : ''}
                  isClose
                  Hide={handleMobileSearchClose}
                />
                {globalError && (
                  <span className="search-error resp-search-error">{globalError ? globalError : 'Please enter valid data'}</span>
                )}
              </div>
            )}
          <div className={`pointer ${isMobileSearch ? 'd-none' : ''}`} onClick={toggleSidebar}>
            <MenuIcon />
          </div>
          <div className={`popup-wrapper ${isOpen ? 'open-menu' : ''}`}>
            <NavbarTabs isPopup setIsOpen={setIsOpen} />
          </div>
          {/* Overlay */}
          {isOpen && <div className="overlay" onClick={toggleSidebar}/>}
        </div>
      </Col>
      <Col xs={4} sm={4} className="web-navbar justify-content-end p-0">
        <NavbarTabs />
      </Col>
      <CustomModal
        close
        show={isOpenModal}
        title="Transaction Details"
        onHide={toggleTransactionModal}
        body={<TransactionDetailsModal data={detailsData} />}
      />
    </Row>
  );
};

export default SubHeader;
